import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { MACS_MAP_CONVERTER_TOKEN, MacsMapConverter } from './macs-map.component.converter'
import { MACS_MAP_ITEM_CONVERTER_TOKEN, MacsMapItemConverter } from './macs-map-item/macs-map-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        macsMapFeature: {
          module: () => import('./macs-map.module').then((m) => m.MacsMapModule),
          cmsComponents: ['map']
        },
      }
    }),
    {
      provide: MACS_MAP_CONVERTER_TOKEN,
      useExisting: MacsMapConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        map: MACS_MAP_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: MACS_MAP_ITEM_CONVERTER_TOKEN,
      useExisting: MacsMapItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        mapitem: MACS_MAP_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class MacsMapFeatureModule {}
